import { Box, SpeedDial, Typography } from "@mui/material";
import { useEffect, useState } from "react";

import { useRef } from "react";
import { useSearchParams } from "react-router-dom";
import profileLogo from "../../../asset/images/profileLogo.png";
import { useTSData } from "../../../common/components/general/TSDataContext";
import TSGrid from "../../../common/components/ui/TSGrid";
import { PORTAIL_GU } from "../../../common/constants/generalConstants";
import config from "../../../config";
import AssistantBot from "../components/AssistantBot";
import PGUAssistantBot from "../components/PGUAssistantBot";

const AssistantBotPage = () => {
  const { isMobile } = useTSData();

  const [mode, setMode] = useState("init");
  const [showWelcomeMessage, setShowWelcomeMessage] = useState(false);
  const [sessionActive, setSessionActive] = useState(null);
  const [open, setOpen] = useState(false);
  const [inputMessage, setInputMessage] = useState("");
  const [searchParams] = useSearchParams();
  const source = searchParams.get("source");
  const [isExpanded, setIsExpanded] = useState(
    searchParams.get("expanded") === "true"
  );
  // Voice recording states
  const [isRecording, setIsRecording] = useState(false);
  const [speechSupported] = useState(true);
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const streamRef = useRef(null);
  const timeoutRef = useRef();

  const globalStyles = `
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.1); }
    100% { transform: scale(1); }
  }
  
  @keyframes ripple {
    0% { 
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 1;
    }
    100% { 
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
  }
`;

  useEffect(() => {
    const styleSheet = document.createElement("style");
    styleSheet.textContent = globalStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

  useEffect(() => {
    timeoutRef.current = setTimeout(() => {
      togleWelcoming();
      setShowWelcomeMessage(true);
    }, 1000);

    return () => clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    function handleMessage(event) {
      // You can add origin check for security
      if (event.data && typeof event.data.isExpanded !== "undefined") {
        setIsExpanded((prev) => !prev);
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  const handleToggle = () => {
    setShowWelcomeMessage(false);
    clearTimeout(timeoutRef.current);
    toggleSize();
    setOpen((prev) => !prev);
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      streamRef.current = stream;

      mediaRecorderRef.current = new MediaRecorder(stream);
      audioChunksRef.current = [];

      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunksRef.current.push(event.data);
        }
      };

      mediaRecorderRef.current.onstop = async () => {
        const audioBlob = new Blob(audioChunksRef.current, {
          type: "audio/webm",
        });

        if (streamRef.current) {
          streamRef.current.getTracks().forEach((track) => track.stop());
        }

        await transcribeAudio(audioBlob);
      };

      mediaRecorderRef.current.start();
      setIsRecording(true);
    } catch (error) {
      console.error("Erreur microphone:", error);
      alert("Impossible d'accéder au microphone");
      setIsRecording(false);
    }
  };

  const stopRecording = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state !== "inactive"
    ) {
      mediaRecorderRef.current.stop();
      setIsRecording(false);
    }
  };

  const transcribeAudio = async (audioBlob) => {
    //setAiIsGenerating(true);

    try {
      const formData = new FormData();
      formData.append("audio", audioBlob, "recording.webm");

      const response = await fetch(config.aiChatBotUrl + "/speech-to-text", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Erreur transcription");
      }

      const data = await response.json();

      if (data.text) {
        setInputMessage((prev) => (prev + " " + data.text).trim());
      }
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de la transcription");
    } finally {
      //setAiIsGenerating(false);
    }
  };

  const handleBoxClick = (event) => {
    event.stopPropagation();
  };

  const handleClose = () => {
    toggleSize();
    setOpen(false);
  };

  const toggleSize = () => {
    window.parent.postMessage(
      { action: "toggleSize" },
      config.crossOrigineUrls
    );
    setIsExpanded(!isExpanded);
  };

  const togleWelcoming = () => {
    window.parent.postMessage({ action: "welcoming" }, config.crossOrigineUrls);
  };

  let content;

  switch (source) {
    case PORTAIL_GU:
      content = (
        <PGUAssistantBot
          isMobile={isMobile}
          handleToggle={handleToggle}
          open={open}
          isExpanded={isExpanded}
          handleBoxClick={handleBoxClick}
          mode={mode}
          setMode={setMode}
          sessionActive={sessionActive}
          setSessionActive={setSessionActive}
          handleClose={handleClose}
          showWelcomeMessage={showWelcomeMessage}
          source={source}
          isRecording={isRecording}
          speechSupported={speechSupported}
          startRecording={startRecording}
          stopRecording={stopRecording}
          
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
        />
      );
      break;
    default:
      content = (
        <DefaultAssistantBot
          isMobile={isMobile}
          handleToggle={handleToggle}
          open={open}
          handleBoxClick={handleBoxClick}
          mode={mode}
          setMode={setMode}
          sessionActive={sessionActive}
          setSessionActive={setSessionActive}
          handleClose={handleClose}
          showWelcomeMessage={showWelcomeMessage}
          isRecording={isRecording}
          speechSupported={speechSupported}
          startRecording={startRecording}
          stopRecording={stopRecording}
          
          inputMessage={inputMessage}
          setInputMessage={setInputMessage}
        />
      );
  }

  return <>{content}</>;
};

const DefaultAssistantBot = (props) => {
  const {
    isMobile,
    handleToggle,
    open,
    handleBoxClick,
    mode,
    setMode,
    sessionActive,
    setSessionActive,
    handleClose,
    showWelcomeMessage,
    isRecording,
    speechSupported,
    startRecording,
    stopRecording,
    inputMessage,
    setInputMessage,
  } = props;
  return (
    <TSGrid container spacing={2}>
      <Box>
        <SpeedDial
          ariaLabel="SpeedDial with Box content"
          sx={{
            position: "fixed",
            top: 0,
            bottom: "5px",
            right: 0,
            left: 0,
            backgroundColor: "transparent",
            "& .MuiFab-root": {
              position: "fixed",
              right: 0,
              bottom: "0px",
              paddingBottom: "25px",
              paddingRight: "25px",
              backgroundColor: "transparent",
              boxShadow: "none",
              "&:hover": { backgroundColor: "transparent" },
            },
          }}
          icon={
            <>
              {showWelcomeMessage && (
                <Typography
                  variant="body2"
                  style={{
                    color: "#000000",
                    position: "fixed",
                    right: "24px",
                    bottom: "90px",
                    backgroundColor: "#F5E2E3",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    fontSize: "12px",
                    whiteSpace: "normal",
                    textTransform: "none",
                  }}
                  sx={{
                    "&::after": {
                      content: '""',
                      position: "absolute",
                      top: "100%",
                      left: "90%",
                      transform: "translateX(-50%)",
                      width: "0",
                      height: "0",
                      borderLeft: "10px solid transparent",
                      borderRight: "10px solid transparent",
                      borderTop: "10px solid #F5E2E3",
                    },
                    "&:hover": {
                      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    },
                  }}
                >
                  Bonjour 👋, Je suis {config.appName}. <br /> Comment puis-je
                  vous aider ?
                </Typography>
              )}
              <img
                src={profileLogo}
                alt="Custom Icon"
                style={{
                  width: 60,
                  height: 60,
                  borderRadius: "50%",
                  boxShadow: "0px 0px 5px 5px rgba(0, 0, 0, 0.1)",
                  transition: "box-shadow 0.3s ease-in-out",
                  padding: "5px",
                }}
                onMouseEnter={(e) => {
                  e.target.style.boxShadow =
                    "0px 0px 5px 5px rgba(0, 0, 0, 0.2)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.boxShadow =
                    "0px 0px 5px 5px rgba(0, 0, 0, 0.1)";
                }}
              />
            </>
          }
          onClick={handleToggle}
        >
          <Box
            sx={{
              position: "absolute",
              bottom: 75,
              right: 0,
              margin: "10px",
              backgroundColor: "white",
              boxShadow: "0px 0px 5px 5px rgba(0, 0, 0, 0.2)",
              borderRadius: 2,
              zIndex: 10,
              pointerEvents: "auto",
              opacity: open ? 1 : 0,
              display: open ? "block" : "none",
              transition: "opacity 0.3s ease",
              width: { xs: "95vw", sm: "500", md: "500", lg: "500" },
            }}
            onClick={handleBoxClick}
          >
            <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
              <AssistantBot
                isMobile={isMobile}
                mode={mode}
                setMode={setMode}
                sessionActive={sessionActive}
                setSessionActive={(e) => setSessionActive(e)}
                handleClose={handleClose}
                isRecording={isRecording}
                speechSupported={speechSupported}
                startRecording={startRecording}
                stopRecording={stopRecording}
                inputMessage={inputMessage}
                setInputMessage={setInputMessage}
              />
            </Box>
          </Box>
        </SpeedDial>
      </Box>
    </TSGrid>
  );
};

export default AssistantBotPage;
